import { Box, Typography } from "@material-ui/core";
import { Button } from "components";
import { usePopup } from "hooks/usePopup";
import { useState } from "react";
import sellerService from "services/sellerService";
import { Dialog } from "shared";

const formatDateToYYYYMMDD = date => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const ReplaceConfirmDialog = ({
  open,
  onClose,
  onSuccess,
  existingCertificate,
  newCertificateData
}) => {
  const { addPopup } = usePopup();
  const [isReplacing, setIsReplacing] = useState(false);

  const handleReplace = async () => {
    if (!existingCertificate?.id || !newCertificateData) return;

    try {
      setIsReplacing(true);

      const payload = {
        seller: newCertificateData.seller.id,
        productBaseId: newCertificateData.productBase.id,
        productBaseName: newCertificateData.productBase.name,
        certifier: newCertificateData.certifier,
        name: newCertificateData.name,
        issueDate: formatDateToYYYYMMDD(newCertificateData.issueDate),
        expirationDate: formatDateToYYYYMMDD(newCertificateData.expirationDate),
        url: newCertificateData.url
      };

      await sellerService.updateCertificate(existingCertificate.id, payload);

      addPopup({
        type: "success",
        title: "Certificado substituído com sucesso!",
        description: "O certificado anterior foi atualizado."
      });

      onSuccess();
    } catch (error) {
      addPopup({
        type: "error",
        title: "Erro ao substituir certificado",
        description:
          error?.response?.data?.message || "Tente novamente mais tarde."
      });
    } finally {
      setIsReplacing(false);
    }
  };

  return (
    <Dialog open={open} handleClose={onClose} title="Certificado Existente">
      <Box mb={3}>
        <Typography variant="body1" gutterBottom>
          Já existe um certificado cadastrado para esta combinação de fornecedor
          e produto base.
        </Typography>

        {existingCertificate && (
          <>
            <Box
              mt={2}
              p={2}
              style={{
                backgroundColor: "#fff3e0",
                borderRadius: "4px",
                borderLeft: "4px solid #ff9800"
              }}
            >
              <Typography
                variant="subtitle2"
                style={{ marginBottom: "0.5rem", fontWeight: 600 }}
              >
                Certificado Atual:
              </Typography>
              <Typography variant="body2" style={{ marginBottom: "0.25rem" }}>
                <strong>Fornecedor:</strong> {existingCertificate.seller_name}
              </Typography>
              <Typography variant="body2" style={{ marginBottom: "0.25rem" }}>
                <strong>Produto Base:</strong>{" "}
                {existingCertificate.product_base_name}
              </Typography>
              <Typography variant="body2" style={{ marginBottom: "0.25rem" }}>
                <strong>Certificado:</strong> {existingCertificate.name}
              </Typography>
              <Typography variant="body2">
                <strong>Certificadora:</strong> {existingCertificate.certifier}
              </Typography>
            </Box>

            <Typography
              variant="body1"
              style={{ marginTop: "1.5rem", fontWeight: 500 }}
            >
              Deseja substituir o certificado existente pelo novo?
            </Typography>
          </>
        )}
      </Box>

      <Box
        display="flex"
        justifyContent="flex-end"
        gap={1}
        style={{ gap: "1rem" }}
      >
        <Button variant="outlined" onClick={onClose} disabled={isReplacing}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleReplace}
          isLoading={isReplacing}
        >
          Substituir
        </Button>
      </Box>
    </Dialog>
  );
};
